import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import MainLayout from "./layout/main/Layout.vue";
import LandingPageLayout from "./layout/starter/SampleLayout.vue";
import PrintSoal from "./layout/PrintSoal.vue";
import LandingPage from "./layout/starter/LandingPage.vue";
import ProfilePage from "./layout/starter/ProfilePage.vue";
import interceptorsSetup from "./middlewares/auth.expired.interceptor";

import Dashboard from "./views/Main/Dashboard.vue";
import Profile from "./views/Main/Profile/Index.vue";
import ClassList from "./views/Main/Class/Index.vue";
import ClassDetail from "./views/Main/Class/Detail.vue";
import MemberList from "./views/Main/Class/MemberList.vue";
import SubjectList from "./views/Main/Subject/Index.vue";
import SubjectDetail from "./views/Main/Subject/Detail.vue";
import StudyInstructions from "./views/Main/Subject/StudyInstructions.vue";
import ModulDetail from "./views/Main/Modul/Index.vue";
import ModulDiscuss from "./views/Main/Modul/Discuss.vue";
import ModulTask from "./views/Main/Modul/Task.vue";
import TaskList from "./views/Main/Task/List.vue";
import StudentTaskList from "./views/Main/Task/StudentTaskList.vue";
import Ujian from "./views/Main/Task/Ujian.vue";
import User from "./views/Main/User/User.vue";
import TahunAjaranList from "./views/Main/TahunAjaran/List.vue";
import UserActivityList from "./views/Main/UserActivity/List.vue";
import UserModulMonitoringList from "./views/Main/UseModulMonitoring/List.vue";
import UserSettingList from "./views/Main/UserSetting/List.vue";
import LockSemester from "./views/Main/LockSemester/List.vue";
import BackgroundSettingList from "./views/Main/BackgroundSetting/List.vue";
import DownloadNilai from "./views/Main/DownloadNilai/List.vue";
import UserAbsenceList from "./views/Main/UserAbsence/List.vue";
import StudentProgress from "./views/Main/StudentProgress/StudentProgress.vue";
import Kelulusan from "./views/Main/Kelulusan/Kelulusan.vue";
import AdminGraduation from "./views/Main/AdminGraduation/AdminGraduation.vue";
import ModulAppraisal from "./views/Main/Modul/Appraisal.vue";
import AppraisalList from "./views/Main/Appraisal/List.vue";
import StudentAppraisalList from "./views/Main/Appraisal/StudentAppraisalList.vue";
import ModulAppraisalQuestion from "./views/Main/Modul/AppraisalQuestion.vue";
import CBTIndex from "./views/Main/CBT/Index.vue";
import PermissionRapor from "./views/Main/PermissionRapor/List.vue";
import FormulirPendaftaran from "./views/Main/FormulirPendaftaran/List.vue";
import FormulirDetail from "./views/Main/FormulirPendaftaran/FormulirDetail.vue";

Vue.use(Router);
Vue.use(interceptorsSetup);

let router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/landing-page",
      component: MainLayout,
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          components: { default: Dashboard },
          meta: {
            requiresAuth: true,
            background: store.getters.bDashboard,
            breadcrumb: "dashboard",
          },
        },
        {
          path: "profile/:userId?",
          name: "profile",
          components: { default: Profile },
          meta: {
            requiresAuth: true,
            breadcrumb: "profile",
          },
        },
        {
          path: "class-list",
          name: "class-list",
          components: { default: ClassList },
          meta: {
            background: "img/bc2.png",
            requiresAuth: true,
            isAdmin: true,
            isTutor: true,
            breadcrumb: "Kelas",
          },
        },
        {
          path: "class-detail/:classId/:taId",
          name: "class-detail",
          components: { default: ClassDetail },
          meta: {
            requiresAuth: true,
            breadcrumb: "Detail Kelas",
          },
        },
        {
          path: "member-list/:classId/:taId",
          name: "member-list",
          components: { default: MemberList },
          meta: {
            requiresAuth: true,
            breadcrumb: "Daftar Anggota",
          },
        },
        {
          path: "subject-list/:classId",
          name: "subject-list",
          components: { default: SubjectList },
          meta: {
            requiresAuth: true,
            isAdmin: true,
            isTutor: true,
            breadcrumb: "Mata Pelajaran",
          },
        },
        {
          path: "subject-detail/:subjectId/:taId",
          name: "subject-detail",
          components: { default: SubjectDetail },
          meta: {
            requiresAuth: true,
            breadcrumb: "Detail Mata Pelajaran",
          },
        },
        {
          path: "study-instructions/:subjectId",
          name: "study-instructions",
          components: { default: StudyInstructions },
          meta: {
            requiresAuth: true,
            breadcrumb: "Petunjuk Belajar",
          },
        },
        {
          path: "student-progress/:subjectId",
          name: "student-progress",
          components: { default: StudentProgress },
          meta: {
            requiresAuth: true,
            breadcrumb: "Perkembangan",
          },
        },
        {
          path: "modul-detail/:modulId/:taId",
          name: "modul-detail",
          components: { default: ModulDetail },
          meta: {
            requiresAuth: true,
            breadcrumb: "List Materi",
          },
        },
        {
          path: "modul-discuss/:modulId",
          name: "modul-discuss",
          components: { default: ModulDiscuss },
          meta: {
            requiresAuth: true,
            breadcrumb: "Diskusi",
          },
        },
        {
          path: "modul-task/:modulId/:taId",
          name: "modul-task",
          redirect: { name: "task-list" },
          component: ModulTask,
          children: [
            {
              path: "/",
              name: "task-list",
              components: { default: TaskList },
              meta: {
                requiresAuth: true,
                breadcrumb: "Penugasan",
              },
            },
            {
              path: "student-task-list/:taskId",
              name: "student-task-list",
              components: { default: StudentTaskList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                isTutor: true,
                breadcrumb: "Tugas Siswa",
              },
            },
          ],
        },
        {
          path: "ujian/:token",
          name: "ujian",
          components: { default: Ujian },
          meta: {
            requiresAuth: true,
            isAdmin: false,
            isTutor: false,
            breadcrumb: "Ujian",
          },
        },
        {
          path: "modul-appraisal/:modulId/:taId",
          name: "modul-appraisal",
          redirect: { name: "appraisal-list" },
          component: ModulAppraisal,
          children: [
            {
              path: "/",
              name: "appraisal-list",
              components: { default: AppraisalList },
              meta: {
                requiresAuth: true,
                breadcrumb: "Penilaian",
              },
            },
            {
              path: "student-appraisal-list/:appraisalId",
              name: "student-appraisal-list",
              components: { default: StudentAppraisalList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                isTutor: true,
                breadcrumb: "Penilaian Siswa",
              },
            },
          ],
        },
        {
          path: "modul-appraisal-question/:modulId/:quizId",
          name: "modul-appraisal-question",
          components: { default: ModulAppraisalQuestion },
          meta: {
            requiresAuth: true,
            breadcrumb: "Penilaian",
          },
        },
        {
          path: "appraisal-test/:appraisalId",
          name: "appraisal-test",
          components: { default: CBTIndex },
          meta: {
            requiresAuth: true,
            breadcrumb: "Penilaian",
          },
        },
        {
          path: "lock-semester",
          name: "lock-semester",
          components: { default: LockSemester },
          meta: {
            requiresAuth: true,
            isAdmin: true,
            breadcrumb: "Lock Semester",
          },
        },
        {
          path: "permission-rapor",
          name: "permission-rapor",
          components: { default: PermissionRapor },
          meta: {
            requiresAuth: true,
            isAdmin: true,
            breadcrumb: "Hak Akses Rapor",
          },
        },
         {
           path: "formulir-pendaftaran",
           name: "formulir-pendaftaran",
           components: { default: FormulirPendaftaran },
           meta: {
             requiresAuth: true,
             isAdmin: true,
             breadcrumb: "Formulir Pendaftaran",
           },
         },
         {
           path: "formulir-pendaftaran/:userId",
           name: "formulir-detail",
           components: { default: FormulirDetail },
           meta: {
             requiresAuth: true,
             isAdmin: true,
             breadcrumb: "Detail Formulir",
           },
         },
        {
          path: "user",
          name: "user",
          redirect: { name: "user-setting-list" },
          component: User,
          children: [
            {
              path: "/",
              name: "user-setting-list",
              components: { default: UserSettingList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                breadcrumb: "Setting User",
              },
            },
            {
              path: "activity",
              name: "user-activity",
              components: { default: UserActivityList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                breadcrumb: "Aktivitas User",
              },
            },
            {
              path: "absence",
              name: "user-absence",
              components: { default: UserAbsenceList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                isTutor: true,
                breadcrumb: "Absensi siswa",
              },
            },
          ],
        },
        {
          path: "background",
          name: "background",
          redirect: { name: "background-setting-list" },
          component: User,
          children: [
            {
              path: "/",
              name: "background-setting-list",
              components: { default: BackgroundSettingList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                breadcrumb: "Setting Background",
              },
            },
          ],
        },
        {
          path: "tahun-ajaran",
          name: "tahun-ajaran",
          redirect: { name: "tahun-ajaran-list" },
          component: User,
          children: [
            {
              path: "/",
              name: "tahun-ajaran-list",
              components: { default: TahunAjaranList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                breadcrumb: "Setting Tahun Ajaran",
              },
            },
          ],
        },
        {
          path: "download-nilai/:classId",
          name: "download-nilai",
          components: { default: DownloadNilai },
          meta: {
            requiresAuth: true,
            breadcrumb: "Download Nilai Siswa",
          },
        },
        {
          path: "graduation",
          name: "graduation",
          components: { default: Kelulusan },
          meta: {
            requiresAuth: true,
            isAdmin: false,
            isTutor: false,
            breadcrumb: "Kelulusan",
          },
        },
        {
          path: "admin-graduation",
          name: "admin-graduation",
          components: { default: AdminGraduation },
          meta: {
            requiresAuth: true,
            isAdmin: true,
            isTutor: false,
            breadcrumb: "Upload Kelulusan",
          },
        },
        {
          path: "user-modul-activity",
          name: "user-modul-activity",
          redirect: { name: "user-modul-activity-list" },
          component: User,
          children: [
            {
              path: "/",
              name: "user-modul-activity-list",
              components: { default: UserModulMonitoringList },
              meta: {
                requiresAuth: true,
                isAdmin: true,
                breadcrumb: "Monitoring User Modul",
              },
            },
          ],
        },
      ],
    },
    {
      path: "/landing-page",
      component: LandingPageLayout,
      children: [
        {
          path: "/",
          name: "landing-page-child",
          components: { default: LandingPage },
          meta: {
            noRequiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/public/profile",
      component: LandingPageLayout,
      children: [
        {
          path: "/",
          name: "profile-page-child",
          components: { default: ProfilePage },
          meta: {
            noRequiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/print-quiz/:quizId",
      name: "print-quiz",
      components: { default: PrintSoal },
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

export default router;

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.matched.some((record) => record.meta.isAdmin) || to.matched.some((record) => record.meta.isTutor)) {
        if (store.getters.isAdmin || store.getters.isTutor) {
          next();
          return;
        } else {
          next("/dashboard");
          return;
        }
      } else {
        next();
        return;
      }
    }
    next("/landing-page");
  } else if (to.matched.some((record) => record.meta.noRequiresAuth)) {
    if (store.getters.isLoggedIn) {
      next("/dashboard");
      return;
    }
    next();
  } else {
    next();
  }
});
